class HbsYatakGrupDTO {
    id: number = 0;
    adi?: string = "";
    organizasyonId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
}
export default HbsYatakGrupDTO;